import React from 'react';
import PropTypes from 'prop-types';

import { addFavoriteVideoAction, removeFavoriteVideoAction, setInverseThemeAction } from './userPreferencesActions';
import { userPreferencesReducer, initialState } from './userPreferencesReducer';

const UserPreferencesContext = React.createContext(null);
const userPreferencesStorageKey = 'REACT-CHALLENGE-USER-PREFERENCES';

function getUserStorageKey(user) {
  return user ? `${userPreferencesStorageKey}-${user.id}` : '';
}

export const UserPreferencesProvider = ({ user, ...otherProps }) => {
  const [state, dispatch] = React.useReducer(userPreferencesReducer, {
    ...initialState,
    ...(localStorage.getItem(getUserStorageKey(user)) ? JSON.parse(localStorage.getItem(getUserStorageKey(user))) : {}),
  });

  function isFavoriteVideo(video) {
    return state.favoriteVideos.find((favoriteVideo) => favoriteVideo.id === video.id);
  }

  const value = {
    ...state,
    isFavoriteVideo,
    addFavoriteVideo: addFavoriteVideoAction(dispatch),
    removeFavoriteVideo: removeFavoriteVideoAction(dispatch),
    setInverseTheme: setInverseThemeAction(dispatch),
  };

  React.useEffect(() => {
    if (!user) {
      return;
    }
    localStorage.setItem(
      getUserStorageKey(user),
      JSON.stringify({
        favoriteVideos: state.favoriteVideos,
        isLightTheme: state.isLightTheme,
      }),
    );
  }, [state.favoriteVideos, user, state.isLightTheme]);

  return <UserPreferencesContext.Provider {...otherProps} value={value} />;
};

UserPreferencesProvider.propTypes = {
  user: PropTypes.any,
};

export default function useUserPreferencesContext() {
  return React.useContext(UserPreferencesContext);
}
